import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mindUpSendSmsApi } from 'api/MindUp/mindUpSendSMSApi';
import { SendSmsType } from 'models/PreciousChild/sendSmsApiTypes';
import { useLoadingStore } from 'store/useLoadingStore';

const useMindUpSendSMSMutation = () => {
    const { setLoading } = useLoadingStore();

    return useMutation({
        mutationFn: async (rqData: SendSmsType) => {
            try {
                setLoading(true);

                const response = await mindUpSendSmsApi.sendSMS(rqData);
                if (response.status === 'ok') return response.data;
                throw new Error('API 응답 오류');
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        onSuccess: () => {},
        retry: 1, // 오류 시 재시도 횟수
    });
};

export default useMindUpSendSMSMutation;
